import styled from "@emotion/styled";
import { Container } from "@gumtree/ui-library";
import { mediaQuery, breakpoints, gutterSizes, colorVariables, fontSizes, fontWeights } from "@gumtree/ui-library/src/base/theme";

export const SellerAdsMainContainer = styled(Container)`
    padding-top: 18px;
`;

export const SellerAdsFlexContainer = styled.div`
    display: grid;
    grid-gap: ${gutterSizes.xlarge};
    margin-bottom: ${gutterSizes.xlarge};

    ${mediaQuery.from(breakpoints.large)} {
        grid-template-columns: minmax(min-content, auto) minmax(300px, 300px);
    }
`;

export const Title = styled.h1`
    margin: ${gutterSizes.base} 0;
    font-size: ${fontSizes.pgLarge};
    line-height: 32px;
    font-weight: ${fontWeights.bold};
`;

export const NumberOfItems = styled.p`
    margin: 0 0 ${gutterSizes.large};
    font-size: ${fontSizes.base};
    line-height: 22px;
    color: ${colorVariables.textPrimary};
`;
